import { IExportColumnModel } from "../../../../../shared/models";

export const ReportRunScheduleColumnList: IExportColumnModel[] = [
]